import React from 'react';
import Image from 'next/image';
import Link from 'next/link';

import { Typography } from 'lighthouse';

import { getStrapiImageUrl } from '@/utilities/strapiImageUrl';

import { ServiceItemType } from '../../models';

export const ServiceItem = ({ service }: { service: ServiceItemType }) => {
    return (
        <Link href={service.url} className='block cursor-pointer'>
            <div
                className='flex h-full flex-col items-center justify-center rounded-lg border border-N200 bg-white p-3 shadow-elevation1
                    transition-all duration-300 hover:-translate-y-1 hover:border-primary/30 hover:shadow-elevation2'>
                <div className='flex h-12 w-12 items-center justify-center'>
                    <Image src={getStrapiImageUrl(service.image.url)} alt={service.title} width={36} height={36} />
                </div>
                <Typography variant='caption' component='h2' className='mt-2 text-center text-[10px] font-bold text-blackHighEmphasis md:text-xs'>
                    {service.title}
                </Typography>
            </div>
        </Link>
    );
};
